module.exports = __webpack_public_path__ + "img/BodmerAG_2.47968a8.jpg";